const Footer = () => {
  return (
    <div className="footer">
      Design Inspired by&nbsp;
      <a
        target="_blank"
        rel="noreferrer"
        href="https://www.apple.com/ca/shop/product/MQ052LL/A/magic-keyboard-with-numeric-keypad-us-english"
      >
        Magic Keyboard
      </a>
    </div>
  );
};

export default Footer;
